// extracted by mini-css-extract-plugin
export default {"cls1":"ProfileFeed-cls1_dDI","cls2":"ProfileFeed-cls2_NiM ProfileFeed-cls1_dDI"};